import { Col, Row } from "antd";
import React from "react";
import ProductTable from "./OrderSummary/ProductTable";
import CustomerTable from "./OrderSummary/CustomerTable";
import PickupTable from "./OrderSummary/PickupTable";
import ExtraNotesTable from "./OrderSummary/ExtraNotesTable";

const Card = (content) => <div className="card-summary">{content}</div>;

const OrderSummary = (props) => {
  const { data, allData, location } = props;

  // 👉 NEW: Helper function to calculate exact order total applying Promo logic
  const calculateCorrectOrderTotal = (orderData) => {
    // We expect orderData to be the full order object (allData)
    if (!orderData?.items || orderData.items.length === 0) {
      return Number(orderData?.amount) || 0;
    }

    let calculatedTotal = 0;

    orderData.items.forEach((item) => {
      const product = item.product;
      const qty = Number(item.qty) || 0;

      // Check if this specific item was a promo product
      if (
        product &&
        (product.is_promo_product === true || product.is_promo_product === 1)
      ) {
        // const unit = Number(product.unit) || 1;
        const promoAmount = Number(product.promo_amount) || 0;

        // Since we changed the Cart logic to send "Bundle Quantity" (e.g. 2 bundles)
        // instead of raw item count, we simply multiply the qty directly by promoAmount.
        calculatedTotal += qty * promoAmount;
      } else {
        // Standard Calculation (Use item.amount if available, fallback to product.amount)
        calculatedTotal +=
          (Number(item.amount) || Number(product?.amount) || 0) * qty;
      }
    });

    return calculatedTotal;
  };

  // 👉 Apply the calculation to get the true total
  const calculatedTotalAmount = calculateCorrectOrderTotal(allData);

  const PaymentDetails = [
    {
      subtotal: calculatedTotalAmount, // Use calculated total
      discount: 0,
      total: calculatedTotalAmount, // Use calculated total
    },
  ];

  const OrderPickupLocation = {
    location: location,
  };

  return (
    <div className="pt-4">
      <div className="basic-text mt-5 mb-2">ORDER DETAILS</div>
      <div className="d-flex gap-4 flex-column">
        <Row gutter={[16, 16]} align="top">
          <Col lg={16} sm={24} md={24}>
            {Card(<ProductTable data={data} allData={allData} />)}
          </Col>
          <Col lg={8} sm={24} md={24} style={{ width: "100%" }}>
            {Card(<CustomerTable details={PaymentDetails} />)}
          </Col>
        </Row>
        <Row gutter={[16, 16]} align="top">
          <Col lg={16} sm={24} md={24}>
            {Card(<PickupTable details={OrderPickupLocation} />)}
          </Col>
          <Col lg={8} sm={24} md={24} style={{ width: "100%" }}>
            {Card(<ExtraNotesTable details={PaymentDetails} />)}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default OrderSummary;
